// @flow
import { createParser, fields } from '../utils/parse';

export const PackagesSeo = createParser('PackagesSeo', {
  canonicalUrl: fields.string('', { path: 'canonical_url' }),
  description: fields.string('', { path: 'meta_description' }),
  h1: fields.string(''),
  footer: fields.string('', { path: 'footer_markdown' }),
  title: fields.string(''),
});

export default PackagesSeo;
